export default {
    customerOrderNoCode: {
        name: '请输入承运商',
        advanceLabel: '承运商',
        value: 'carrierName',
        advanceConfig: [
            { prop: 'supplierNameCn', value: '承运商名称' },
            { prop: 'supplierCode', value: '承运商编码' }
        ],
        tableConfig: [
            { prop: 'supplierNameCn', value: '承运商名称' },
            { prop: 'supplierCode', value: '承运商编码' },
            { prop: 'transNameListStr', value: '采购渠道' }
        ],
        advanceNotSearch: true,
        queryConditionRequired: true,
        method: 'post',
        advanceUrl: 'srm/supplier/search',
        prefix: '/api-tms/',
        cbParams: ['supplierNameCn#carrierName', 'supplierCode#supplierCode', 'transTypeListStr#transType',
            'transNameListStr#tranName', 'supplierCode#carrierCode', 'propertyNature', 'whiteList#procurementChannelFlag'],
        advanceCascade: 'professionalCompanyList,siteCodeList,supplierStatus,businessTypeStatus,switchSrm,taskNoList'
    },
    // 车牌
    vehicleCardLists: {
        method: 'post',
        name: '请输入车牌号',
        advanceLabel: '车牌号',
        value: 'vehicleCard',
        advanceConfig: [
            { prop: 'licensePlateNo', value: '车牌' },
            { prop: 'maxVolume', value: '载货体积' },
            { prop: 'carTypeNameCn', value: '车型' },
            { prop: 'carType', value: '车型编码' }
        ],
        tableConfig: [
            { prop: 'licensePlateNo', value: '车牌' },
            { prop: 'maxVolume', value: '载货体积' },
            { prop: 'carTypeNameCn', value: '车型' },
            { prop: 'carType', value: '车型编码' }
        ],
        cbParams: ['licensePlateNo#vehicleCard', 'maxVolume#cargoVolumeStr', 'carTypeNameCn#equipmentName', 'carType#equipmentType', 'deviceNo'],
        prefix: '/api-srm-web/',
        advanceUrl: 'basis/supplierCarInfos/getEnableCarListBySupplierCode',
        advanceCascade: 'supplierCode,routeNoList'
    },
    // 司机
    driverLists: {
        method: 'post',
        name: '请输入司机',
        advanceLabel: '司机',
        value: 'driver',
        advanceConfig: [
            { prop: 'driverName', value: '司机' },
            { prop: 'driverPhone', value: '电话' },
            { prop: 'driverCode', value: 'DN编码' },
            { prop: 'driverIdCard', value: '身份证号' }
        ],
        tableConfig: [
            { prop: 'driverName', value: '司机' },
            { prop: 'driverPhone', value: '电话' },
            { prop: 'driverCode', value: 'DN编码' },
            { prop: 'driverIdCard', value: '身份证号' }
        ],
        prefix: '/api-srm-web/',
        advanceUrl: 'basis/supplierDriverInfo/getEnableDriverListBySupplierCode',
        cbParams: ['driverName#driver', 'driverPhone#driverContactWay', 'driverIdCard#driverIdentity', 'onWayContactCategory', 'onWayContactName', 'onWayContactPhone', 'driverCode#driverNo'],
        advanceCascade: 'supplierCode,routeNoList'
    },
    // 车牌
    controlVehicleCardLists: {
        method: 'post',
        name: '请输入车牌号',
        advanceLabel: '车牌号',
        value: 'vehicleCard',
        advanceConfig: [
            { prop: 'licensePlateNo', value: '车牌' }
        ],
        tableConfig: [
            { prop: 'licensePlateNo', value: '车牌' },
            { prop: 'maxVolume', value: '载货体积' },
            { prop: 'carTypeNameCn', value: '车型' },
            { prop: 'carType', value: '车型编码' }
        ],
        cbParams: ['licensePlateNo#vehicleCard', 'maxVolume#cargoVolumeStr', 'carTypeNameCn#equipmentName', 'carType#equipmentType', 'deviceNo'],
        prefix: '/api-tms/',
        advanceUrl: '/dispatch/resource/car/query',
        advanceCascade: 'supplierCode,siteCodeList,checkResource'
    },
    // 司机
    controlDriverLists: {
        method: 'post',
        name: '请输入司机',
        advanceLabel: '司机',
        value: 'driver',
        advanceConfig: [
            { prop: 'driverName', value: '司机' },
            { prop: 'driverPhone', value: '电话' },
            { prop: 'driverCode', value: 'DN编码' },
            { prop: 'driverIdCard', value: '身份证号' }
        ],
        tableConfig: [
            { prop: 'driverName', value: '司机' },
            { prop: 'driverPhone', value: '电话' },
            { prop: 'driverCode', value: 'DN编码' },
            { prop: 'driverIdCard', value: '身份证号' }
        ],
        prefix: '/api-tms/',
        advanceUrl: 'dispatch/resource/driver/query',
        cbParams: ['driverName#driver', 'driverPhone#driverContactWay', 'driverIdCard#driverIdentity', 'onWayContactCategory', 'onWayContactName', 'onWayContactPhone', 'driverCode#driverNo'],
        advanceCascade: 'supplierCode,siteCodeList,checkResource'
    },
    // 税率
    taxRateLists: {
        name: '请输入税率',
        advanceLabel: '税率',
        value: 'taxRate',
        advanceConfig: [
            { prop: 'percentageRateStr', value: '税率百分比' },
            { prop: 'taxRateCode', value: '税率代码' }
        ],
        tableConfig: [
            { prop: 'percentageRate', value: '税率百分比' },
            { prop: 'taxRateCode', value: '税率代码' }
        ],
        advanceUrl: 'efTaxRate/popTaxRate/in',
        cbParams: ['percentageRate#taxRate']
    },
    // 班次
    vehicleScheduleNames: {
        name: '班次',
        value: 'vehicleScheduleName',
        type: 'advance',
        dialogWidth: '900px',
        advanceConfig: [
            { prop: 'vehicleScheduleName', value: '班次名称' },
            { prop: 'vehicleScheduleCode', value: '班次编码' }
        ],
        tableConfig: [
            { prop: 'vehicleScheduleCode', value: '班次编码' },
            { prop: 'vehicleScheduleName', value: '班次名称' },
            { prop: 'senderCodeName', value: '发货地', width: '200px' },
            { prop: 'receiverCodeName', value: '收货地', width: '200px' },
            { prop: 'bcArrivalTime', value: '应到车时间' },
            { prop: 'bcDepartTime', value: '应发车时间' },
            { prop: 'bcArriveTime', value: '应抵达时间' }
        ],
        advanceUrl: 'vehicleScheduleRules/timeLimit',
        cbParams: ['vehicleScheduleCode', 'vehicleScheduleName', 'bcArriveTime', 'bcDepartTime', 'bcArrivalTime', 'senderCodeName', 'receiverCodeName'],
        prefix: '/api-otp/',
        method: 'post',
        advanceCascade: 'companyCode'
    },
    whNames: {
        name: '提货仓',
        value: 'whName',
        type: 'advance',
        multiple: true,
        border: true,
        dialogWidth: '800px',
        advanceCode: 'cdwhName',
        multipleTableColumn: { prop: 'cdwhName', value: '仓库名称' },
        advanceConfig: [
            { prop: 'cdwhName', value: '仓库名称' },
            { prop: 'whCode', value: '仓库编码' }
        ],
        tableConfig: [
            { prop: 'whCode', value: '仓库编码', width: '200px' },
            { prop: 'cdwhName', value: '仓库名称' }
        ],
        advanceUrl: 'cdWarehouse/search?cdwhIsStop=0',
        cbParams: ['whCode', 'cdwhName#whName']
    },
    transUnitNames: {
        'method': 'post',
        'name': '请输入会计主体',
        'advanceLabel': '会计主体',
        'value': 'transUnitName',
        'dialogWidth': '1200px',
        'advanceConfig': [
            { 'prop': 'accountName', 'value': '会计主体名称' },
            { 'prop': 'accountCode', 'value': '会计主体编码' }
        ],
        'tableConfig': [
            { 'prop': 'contractName', 'value': '合同名称' },
            { 'prop': 'legalContractCode', 'value': '法务合同号' },
            { 'prop': 'accountName', 'value': '会计主体名称' },
            { 'prop': 'accountCode', 'value': '会计主体编码' },
            { 'prop': 'transportContractNo', 'value': '合同单据编码' },
            { 'prop': 'paymentTermsName', 'value': '付款条件' },
            { 'prop': 'remark', 'value': '背景' }
        ],
        'prefix': '/api-tms/',
        'advanceUrl': 'contract/info/matchContract',
        'cbParams': [
            'accountName#transUnitName',
            'accountCode#transUnitCode',
            'paymentTerms',
            'transportContractNo'
        ],
        'advanceCascade': 'taskDataList'
    },
    advanceDialogConfig: {
        name: '调车单号',
        value: 'orderNo',
        type: 'advance',
        unfold: true,
        advanceConfig: [
            { prop: 'orderNos', value: '调车单号' }
        ],
        tableConfig: [
            { prop: 'orderNo', value: '调车单号' },
            { prop: 'carrierName', value: '承运商' },
            { prop: 'carLicense', value: '车牌号' },
            { prop: 'driverName', value: '司机名称' },
            { prop: 'driverCode', value: '司机编码' }
        ],
        prefix: '/api-tms/dispatch',
        advanceUrl: '/ntp/order/list',
        method: 'post',
        noPagination: true,
        cbParams: ['orderNo#orderNo', 'carrierName', 'carLicense', 'driverName', 'driverCode', 'ntpManagerReverseProcessFlag',
            'freightType', 'quoteMode', 'driverUnitFreight', 'transportAmount', 'accountName', 'accountCode', 'contractCode', 'natureType'],
        advanceCascade: 'forwardNtpDeploy'
    },
    AdmittRules: {
        carrierName: [
            {
                required: true,
                message: '承运商不能为空',
                trigger: ['blur']
            }
        ],
        shippingType: [
            {
                required: true,
                message: '发运类型不能为空',
                trigger: ['change']
            }
        ],
        transportType: [
            {
                required: true,
                message: '运输方式不能为空',
                trigger: ['blur', 'change']
            }
        ],
        vehicleCard: [
            {
                required: true,
                message: '车牌不能为空',
                trigger: ['blur', 'change']
            }
        ],
        conveniently: [
            {
                required: true,
                message: '是否顺路带回不能为空',
                trigger: 'blur'
            }
        ],
        procurementChannel: [
            {
                required: true,
                message: '采购渠道不能为空',
                trigger: ['blur']
            }
        ],
        dispatchType: [
            {
                required: true,
                message: '调度类型不能为空',
                trigger: ['blur', 'change']
            }
        ],
        equipmentTypeMapping: [
            {
                required: true,
                message: '伊莱克斯车型不能为空',
                trigger: 'change'
            }
        ],
        driver: [
            {
                required: true,
                message: '司机不能为空',
                trigger: ['blur', 'change']
            }
        ],
        transportationCost: [
            {
                required: true,
                message: '运输成本不能为空',
                trigger: 'blur'
            },
            {
                pattern: /^(([1-9][0-9]{0,4})([.][0-9]{0,2})?|100000|100000.0|100000.00|!0.0|!0.00|!0)$/,
                message: '仅可输入数字，不能为0，支持小数点后2位；包含小数点共9位',
                trigger: 'blur'
            }
        ],
        transportationIncome: [
            {
                pattern: /^(([1-9][0-9]{0,4})([.][0-9]{0,2})?|100000|100000.0|100000.00|!0.0|!0.00|!0)$/,
                message: '仅可输入数字，不能为0，支持小数点后2位；包含小数点共9位',
                trigger: 'blur'
            }
        ],
        oilcardPayAmount: [
            {
                pattern: /^([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])|(0\.[1-9]\d*)$/,
                message: '数值必须大于0',
                trigger: 'blur'
            }
        ],
        taxRate: [
            {
                required: true,
                message: '税率不能为空',
                trigger: 'blur'
            }
        ],
        onWayContactCategory: [
            {
                required: true,
                message: '请选择在途联系类别',
                trigger: 'change'
            }
        ],
        onWayContactName: [
            {
                required: true,
                message: '请输入在途联系人',
                trigger: 'blur'
            },
            { max: 20, message: '长度在20个字符', trigger: 'blur' }
        ],
        onWayContactPhone: [
            {
                required: true,
                message: '请输入在途联系人电话',
                trigger: 'blur'
            },
            { pattern: /^1[3-9](\d{9})$/, message: '请输入正确的手机号', trigger: ['change'] },
            { max: 11, message: '请输入11位手机号', trigger: 'change' }
        ],
        transUnitName: [
            {
                required: true,
                message: '会计主体不能为空',
                trigger: ['blur', 'change']
            }
        ],
        orderNo: [
            {
                required: true,
                message: '调车单号不能为空',
                trigger: ['blur', 'change']
            }
        ],
        tyOutputTime: [
            {
                required: true,
                message: '预约到厂日期不能为空',
                trigger: ['blur', 'change']
            }
        ],
        tyCarTypeName: [
            {
                required: true,
                message: '统一车型不能为空',
                trigger: ['blur', 'change']
            }
        ],
        ztbTransportFlag: [
            { required: true, message: '请选择是否直通宝转运', trigger: 'change' }
        ],
        driverPrintTemplate: [
            { required: true, message: '请选择自助打印模板', trigger: 'change' }
        ]
    }
};
